module.exports = __webpack_public_path__ + "static/media/BubbleChart.a59bce47.svg";